import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">投稿爆料</h2>
          <p className="mt-2 text-sm text-foreground-500">{contactData.subtitle}</p>
        </div>

        <div className="bg-background-50 rounded-2xl p-6 md:p-10 max-w-2xl mx-auto">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed text-center">
            {contactData.description}
          </p>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
            {contactData.channels.map((ch, idx) => (
              <div key={idx} className="text-center p-5 rounded-xl bg-background-100 hover:bg-primary-50 transition-colors duration-300">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className={`${ch.icon} text-xl`}></i>
                </div>
                <p className="mt-3 text-xs font-semibold text-foreground-700">{ch.label}</p>
                <p className="mt-1 text-sm text-primary-600 font-medium break-all">{ch.value}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 text-center">
            <p className="text-xs text-foreground-400">
              我们承诺严格保护爆料人隐私，绝不透露信息来源
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}